import React from 'react'
import ValidateLiveness from './validate-liveness'

const ValidateLivenessKyc = () => <ValidateLiveness kyc />

export default ValidateLivenessKyc
